import { render, staticRenderFns } from "./PickUserOrganization.vue?vue&type=template&id=2122dc46&scoped=true&"
import script from "./PickUserOrganization.vue?vue&type=script&lang=js&"
export * from "./PickUserOrganization.vue?vue&type=script&lang=js&"
import style0 from "./PickUserOrganization.vue?vue&type=style&index=0&id=2122dc46&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2122dc46",
  null
  
)

export default component.exports